import type {
  RootCauseMethod,
  SafetyIncidentSeverity,
  SafetyIncidentStatus,
  SafetyIncidentType,
} from './types';

export const INCIDENT_TYPE_LABEL: Record<SafetyIncidentType, string> = {
  accidente_con_baja: 'Accidente con baja',
  accidente_sin_baja: 'Accidente sin baja',
  incidente: 'Incidente',
  cuasi_accidente: 'Cuasi accidente',
  enfermedad_profesional: 'Enfermedad profesional',
};

export const SEVERITY_LABEL: Record<SafetyIncidentSeverity, string> = {
  leve: 'Leve',
  grave: 'Grave',
  mortal: 'Mortal',
};

export const STATUS_LABEL: Record<SafetyIncidentStatus, string> = {
  abierto: 'Abierto',
  en_investigacion: 'En investigación',
  acciones_definidas: 'Acciones definidas',
  cerrado: 'Cerrado',
};

export const ROOT_CAUSE_METHOD_LABEL: Record<RootCauseMethod, string> = {
  cinco_porques: '5 porqués',
  ishikawa: 'Ishikawa',
  otro: 'Otro',
};

export function severityBadgeClass(severity: SafetyIncidentSeverity): string {
  if (severity === 'mortal') return 'bg-red-100 text-red-800 dark:bg-red-950 dark:text-red-200';
  if (severity === 'grave') return 'bg-orange-100 text-orange-800 dark:bg-orange-950 dark:text-orange-200';
  return 'bg-yellow-100 text-yellow-800 dark:bg-yellow-950 dark:text-yellow-200';
}

export function statusBadgeClass(status: SafetyIncidentStatus): string {
  if (status === 'cerrado') return 'bg-green-100 text-green-800 dark:bg-green-950 dark:text-green-200';
  if (status === 'acciones_definidas') {
    return 'bg-blue-100 text-blue-800 dark:bg-blue-950 dark:text-blue-200';
  }
  if (status === 'en_investigacion') {
    return 'bg-purple-100 text-purple-800 dark:bg-purple-950 dark:text-purple-200';
  }
  return 'bg-muted text-muted-foreground';
}

export function formatIndex(value: number | null): string {
  return value == null ? '—' : value.toFixed(2);
}

export function defaultPeriodRange(): { from: string; to: string } {
  const now = new Date();
  const from = new Date(now.getFullYear(), 0, 1);
  return { from: from.toISOString().slice(0, 10), to: now.toISOString().slice(0, 10) };
}
